module.exports = __webpack_public_path__ + "f603c426d12eccd661d5ea0bfff52774.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/recomment1.png
// module id = 3230
// module chunks = 0